import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

interface ProgressBarComponentProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBarComponent: React.FC<ProgressBarComponentProps> = ({
  currentStep,
  totalSteps,
}) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="mt-4 w-100">
      <ProgressBar now={progress} label={`${Math.round(progress)}%`} />
      <p className="mt-2 text-muted">
        Step {currentStep} of {totalSteps}
      </p>
    </div>
  );
};

export default ProgressBarComponent;
